module.exports = __webpack_public_path__ + "img/m2.43f5649f.jpeg";